import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const DalhousieUniversity = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="Dalhousie University"
      universityShortName="Dalhousie"
      slug="dalhousie-university"
      seoTitle="Dalhousie University Study Rooms | Halifax Campus Study Guide"
      seoDescription="Complete guide to study rooms at Dalhousie University. Find Killam Library, Kellogg Library, and group study spaces. Plus free 24/7 online alternative."
      seoKeywords="dalhousie study rooms, dalhousie library, killam library, halifax university study spaces, dal library"
      canonicalUrl="/study-room/dalhousie-university/"
      heroDescription="A comprehensive guide to study rooms at Dalhousie in Halifax and Truro, including Killam Library and specialized spaces."
      libraryWebsiteUrl="https://libraries.dal.ca/"
      libraryWebsiteName="Dalhousie Libraries"
      studySpaces={[
        {
          name: "Killam Library",
          features: "Group study rooms for up to six people; main study hub.",
          feedback: "Rooms aren't soundproof and sound carries into quiet areas."
        },
        {
          name: "Kellogg Library",
          features: "Rooms for up to 15 people for larger groups.",
          feedback: "Good for larger group projects."
        },
        {
          name: "Law Library",
          features: "Rooms for up to 10 people with quieter atmosphere.",
          feedback: "Great for silent study; explore upper floors."
        },
        {
          name: "Sexton Library",
          features: "Rooms for up to 4 people for small teams.",
          feedback: "Intimate space for small group work."
        },
        {
          name: "MacRae Library (Truro)",
          features: "Rooms for up to 12 people at the Agricultural Campus.",
          feedback: "Good option for Truro campus students."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            Pick a library based on group size—<strong>Kellogg for larger groups</strong>, <strong>Sexton for small teams</strong>. Always confirm your booking at the desk to avoid cancellation.
          </p>
          <p className="mb-4">
            For silent study, explore the <strong>Law Library or upper floors of Killam</strong>. Bookings open one week in advance and are made in 30-minute increments for up to two hours per day.
          </p>
          <p>
            Students like having different campus options but complain about limited daily booking time and the need to confirm reservations at help desks.
          </p>
        </>
      }
      summaryTips={[
        "Choose by group size: Kellogg (15), MacRae (12), Law (10), Killam (6), Sexton (4).",
        "Confirm at the desk: Unclaimed bookings cancelled after 15 minutes.",
        "Book in 30-minute increments: Up to two hours per day allowed.",
        "Try Law Library for silence: Quieter atmosphere for focused work.",
        "Use CSW for longer sessions: No two-hour daily limits in virtual study rooms."
      ]}
    />
  );
};

export default DalhousieUniversity;
